import React from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

const styles = {
  main: {
    'font-size': '30px',
    minHeight: '50px',
  },
  added: {
    'font-size': '18px',
    color: '#00c853',
  },
}

class CreditsProgress extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      credits: props.user_credits,
      credits_earned: 0,
    }
  }

  componentDidMount() {
    const velocity = 50
    setTimeout(() =>
      this.addCredits(this.props.credits_to_add, velocity)
    , 800)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  addCredits(credits_to_add, velocity) {
    if (credits_to_add > 0) {
      this.setState({
        credits: this.state.credits + 1,
        credits_earned: this.state.credits_earned + 1,
      }, () => {
        this.timer = setTimeout(
          () => this.addCredits(credits_to_add - 1, velocity)
        , velocity)
      })
    }
  }

  render() {
    return (
      <div
        style={styles.main}
        className="mui--text-center"
      >
        <FontAwesome name="diamond" />
        {`   ${(this.state.credits || 0).toLocaleString()}`}
        <span style={styles.added}>
          { `  (+${this.state.credits_earned})` }
        </span>
      </div>
    )
  }
}

CreditsProgress.propTypes = {
  user_credits: React.PropTypes.number,
  credits_to_add: React.PropTypes.number,
}

const mapStateToProps = state => ({
  credits_to_add: state.missions.answerMission.progress.earned_for_winning.credits_to_add,
  user_credits: state.missions.answerMission.progress.earned_for_winning.user.credits,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(CreditsProgress)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/CreditProgress/index.jsx